import queryString from 'query-string';
import { ENDPOINTS } from 'config/endpoints';
import { useQuery } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { Task } from 'crono-fe-common/types/task';

export default function useGetTaskCall(
  prospectId?: string | null,
  callId?: string | null,
  withLog = false,
) {
  const queryParams = queryString.stringify({
    prospectId,
    callId,
    withLog,
  });

  const request: Request = {
    url: `${ENDPOINTS.events.task.call}?${queryParams}`,
    config: {
      method: 'get',
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.events.task.call, prospectId, callId, withLog],
    queryFn: () => client(request),
    staleTime: 5 * 60 * 1000,
    enabled: prospectId !== null && callId !== null,
  };

  const { data, ...rest } = useQuery<Response<Task | null>, CronoError>(
    requestConfig,
  );

  return { data, ...rest };
}
